import styled from 'styled-components';

const PanelContainer = styled.div`
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 400px;
	padding: 30px;
	background-color: #111314;
	border-radius: 10px;
`;

export { PanelContainer };
